module.exports = __webpack_public_path__ + "img/lady.af0fb7a3.jpg";